<script setup lang="ts">
</script>

<template>
  <v-row>
    <v-col align="center">
      <v-progress-circular class="ma-10" :width="5" :size="100" indeterminate color="var(--yellow)">
      </v-progress-circular>
    </v-col>
  </v-row>
</template>